import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate,DownloadFile } from './Function';
import { usePage } from '../PageContext';
import { Card,Table,Placeholder } from 'react-bootstrap';
const EventsDetails = ({htaccess}) => 
{
    const { currentPage } = usePage();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[Events,setEvents]=useState([]);
    useEffect(()=>
    {
        const EventsDetails = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"events/details/"+htaccess);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.se_id + "/seFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.se_id + "/seFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].seFile = el.upp;
                            result[i].seFileHi = el.upb;
                        });
                        setEvents(result[0]);
                        currentPage(result[0]);                 
                    }).catch(error => 
                    {
                        console.error('EventsDetails File :', error);
                    });
                }
                if( global.config.IsPrint === true ) { console.info('EventsDetails : Result',result); }
            } 
            catch (error)
            {
                console.error('EventsDetails : Error', error.message);
            }
            finally
            {
                setLoading(false);
            }
        };
        EventsDetails();
        // eslint-disable-next-line
    },[htaccess])
    return (
        <Card>
            <Card.Header className='text-center fs-3 text-uppercase'>
                {t('EventDetails')}
            </Card.Header>
            <Card.Body>                    
                {isLoading ? (
                <Table responsive bordered className='mb-0'>
                <tbody>
                    {[...Array(5)].map((_,index)=>(
                    <tr key={index}>
                        <th className="table-success w-25"><Placeholder xs={10} /></th>
                        <td className="text-center"><Placeholder xs={10} /></td>
                    </tr>
                    ))}
                </tbody>
                </Table>
                ) : (
                <React.Fragment>
                {Events.se_id > 0 ? (
                <Table responsive bordered className='mb-0'>
                <tbody>
                    <tr>
                        <th className="table-success w-25 text-end">{t('Title')}:</th>
                        <th dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (Events.se_display_en === "1" ? Events.se_name_hi || '' : Events.se_name_hi || Events.se_name) : Events.se_name }}></th>
                    </tr>                                    
                    <tr>
                        <th className="table-success w-25 text-end">{t('Content')}:</th>
                        <th dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (Events.se_display_en === "1" ? Events.se_description_hi || '' : Events.se_description_hi || Events.se_description) : Events.se_description }}></th>
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('OrganisedBy')}:</th>
                        <td>{(appLanguage === 'hi' && Events.departments.sd_fullname_hi) ? Events.departments.sd_fullname_hi : Events.departments.sd_fullname}</td>
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('Download')}:</th>
                        <td dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,Events.seFile,Events.seFileHi)}} />                            
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('Duration')}:</th>
                        <td>{formatDate(Events.se_start_duration)} TO {formatDate(Events.se_end_duration)}</td>
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('UploadDate')}:</th>
                        <td>{formatDate(Events.se_date)}</td>
                    </tr>
                    <tr>
                        <th className="table-success w-25 text-end">{t('PhotosVideos')}:</th>
                        <td></td>
                    </tr>
                </tbody>
                </Table>
                ) : (
                <div className='text-center lead fw-bold'>
                    {appLanguage === 'hi' ? 'हम वे घटनाएँ नहीं ढूँढ़ पा रहे हैं जिनका विवरण हम आपको दिखाना चाहते थे।' : "We can't find the events whose details we wanted to show you."}
                </div>
                )}
                </React.Fragment>                    
                )}                    
            </Card.Body>
        </Card>
    );
}
export default EventsDetails;